import React from 'react'
import './nav.css'
import {FaHome} from 'react-icons/fa' 
import {BiUserCircle} from 'react-icons/bi'
import {BsFillBagFill} from 'react-icons/bs'
import {BsFillFolderFill} from 'react-icons/bs'
import {RiContactsLine} from 'react-icons/ri'
import {useState} from 'react'

const Nav = () => {
  const [activeNav, setActiceNav] = useState('#')
  return (
    <nav>
      <a href="#" onClick={() => setActiceNav('#')} className={activeNav === '#' ? 'active': ''}><FaHome /></a>
      <a href="#about" onClick={() => setActiceNav('#about')} className={activeNav === '#about' ? 'active': ''}><BiUserCircle /></a>
      <a href="#experience" onClick={() => setActiceNav('#experience')} className={activeNav === '#experience' ? 'active': ''}><BsFillBagFill /></a>
      <a href="#portfolio" onClick={() => setActiceNav('#portfolio')} className={activeNav === '#portfolio' ? 'active': ''}><BsFillFolderFill /></a>
      <a href="#contact" onClick={() => setActiceNav('#contact')} className={activeNav === '#contact' ? 'active': ''}><RiContactsLine /></a>
    </nav>
  )
}

export default Nav